































































import { Vue, Component } from "vue-property-decorator";
import { SwipeCell, Checkbox, CheckboxGroup, Search, Toast } from "vant";
import SystemService from "@/service/UserService";
import { RoleInfoEntity } from "@/model/system";
import { RoleType } from "../../../model/Base";
import dataShare from "../dataShare";
import * as _ from "lodash";
import { QueryPolicyModel } from "@/model/FlightPolicy";

@Component({
  name: "addPassengers",
  components: {
    [SwipeCell.name]: SwipeCell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Search.name]: Search,
  },
})
export default class AddPassengers extends Vue {
  //data
  checked = true;
  get selected(): RoleInfoEntity[] {
    return this.dataShare.consumers;
  }
  dataShare = dataShare;

  consumers: RoleInfoEntity[] = [];
  temporarys: RoleInfoEntity[] = [];
  where = {
    Superior: { RootID: "", RoleID: "" },
    RoleType: RoleType.User,
    RoleName: "",
    Keywords: "",
    PageNo: 1,
    PageSize: 50,
    RecordCount: 0,
    SuperiorTypes: [1314, 1317],
  };

  //mounted
  mounted() {
    this.selectedPassengers = dataShare.consumers;
    let consumers = this.selected;
    if (consumers && consumers.length > 0) {
      consumers.forEach((consumer: any) => {
        if (consumer.RoleID) {
          return;
        }
        this.temporarys.push(consumer);
      });
    }

    this.onSearch();
  }
  get max() {
    return this.$route.query.max || 9;
  }

  isSearch = false;
  isContinue = false;

  onSearch(): any {
    if (this.isContinue) {
      return;
    }
    if (this.isSearch) {
      this.isContinue = true;
      return;
    }
    this.isSearch = true;
    let context = this;

    let RootID = context.profile.CompanyID;
    context.where.Superior.RootID = RootID!;
    return SystemService.getRoleList(context.where).then(res => {
      context.isSearch = false;
      if (res.isSucc) {
        let firstConsumers: any = _.find(res.result!.entities!, item => item.RoleID == this.profile.UserID);
        if (firstConsumers) {
          _.remove(res.result!.entities!, firstConsumers);
        }
        context.consumers = res.result!.entities!;
        if (firstConsumers) {
          context.consumers.unshift(firstConsumers);
        }
        this.ensure();
      }
      if (context.isContinue) {
        context.isContinue = false;
        this.onSearch();
      }
    });
  }

  clean(consumers: any, check: any) {
    for (let i = 0; i < consumers && consumers.length; i++) {
      const ele = consumers[i];
      if (check(ele)) {
        consumers.splice(i, 1);
        i--;
      }
    }
  }
  ensure() {
    if (this.selected.length == 0) {
      return;
    }
    for (let j = 0; j < this.selected.length; j++) {
      const selected = this.selected[j];
      if (!selected.RoleID) {
        continue;
      }

      for (let i = 0; i < this.consumers.length; i++) {
        const consumer = this.consumers[i];

        if (selected.RoleID == consumer.RoleID) {
          this.selected.splice(j, 1, consumer);
          break;
        }
      }
    }
  }

  //methods
  editRole() {
    if (!this.where.Keywords) {
      this.$root.$toast.success(this.$root.$t("mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi") as string);
      return;
    }
    let consumer: any = {
      RoleID: "",
      RoleName: this.where.Keywords,
      SuperiorName: this.$root.$t("mall_modules_addpassengers_linke") as string,
    };
    this.temporarys.push(consumer);
    this.selected.push(consumer);
    this.where.Keywords = "";
    this.onSearch();
  }
  back() {
    history.back();
  }
  changeSelected() {
    let max: number = this.$route.query.max as any;
    if (max && this.selectedPassengers.length > max) {
      this.$root.$toast.success(`一张订单最多添加${max}名乘客，如有更多人出行，请联系客服或另行下单预订。 `);
      this.selectedPassengers.splice(max, this.selectedPassengers.length - max);
      return false;
    }
  }
  selectedPassengers = [];
  confirm() {
    dataShare.consumers = this.selectedPassengers;
    this.back();
  }
}
